import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "set-timer"
};
const _hoisted_2 = {
  class: "filter-timer"
};
const _hoisted_3 = {
  key: 0,
  class: "test-location"
};
const _hoisted_4 = {
  class: "location"
};
const _hoisted_5 = {
  class: "btn-group"
};
import { ref, computed, watch } from 'vue';
import { Search, Plus, Close, User, HomeFilled } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { storeToRefs } from 'pinia';
import { v4 as uuidv4 } from 'uuid';
import { mctRequest } from '@/api/axios';
import AddTimer from './AddTimer.vue';
import DeleteTimer from './DeleteTimer.vue';
import SelectTimerRule from './SelectTimerRule.vue';
import TimerRule from './TimerRule.vue';
import DeleteTimerRule from './DeleteTimerRule.vue';
import DialogHeader from '@/components/dialog-header/index.vue';
import { useUserDefaultSettingStore } from '@/store/user';
import { useSetTimerStore } from '@/store/setTimer';
import { deepClone } from '@/utils/util';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const tableRowClassName = ({
      rowIndex
    }) => {
      if (rowIndex === 0 && agentLevel.value === 'Zone') {
        return 'selected-zone-row';
      }
      return '';
    };
    const store = useUserDefaultSettingStore();
    const {
      userCEC
    } = storeToRefs(store);
    const useSetTimer = useSetTimerStore();
    const {
      clusterId,
      agentLevel,
      setTimerDialogVisible,
      addTimerDialogVisible,
      deleteTimerDialogVisible,
      selectTimerRuleDialogVisible,
      timerRuleDialogVisible,
      deleteTimerRoleDialogVisible,
      refreshSetTimer,
      zoneId
    } = storeToRefs(useSetTimer);
    const filterTimer = ref('');
    const tableData = ref([]);
    const getTimerList = async () => {
      tableData.value = [];
      const config = {
        url: `/monitor/timer-setting/${clusterId.value}`
      };
      const {
        timerSettings
      } = await mctRequest.request(config);
      originalTableData = deepClone(timerSettings);
      timerSettings.sort((a, b) => {
        if (agentLevel.value === 'Cluster') {
          return a.zoneName.localeCompare(b.zoneName);
        }
        // Put the zone at the beginning if user clicks zone timer setting
        if (a.zoneId === zoneId.value) return -1;
        if (b.zoneId === zoneId.value) return 1;
        return a.zoneName.localeCompare(b.zoneName);
      });
      const zoneIdSet = new Set();
      timerSettings.forEach(zoneTimer => {
        zoneTimer.id = zoneTimer.zoneId;
        if (zoneTimer.testLocation ?? '' !== '') {
          const timerRule = zoneTimer.timerRuleList;
          if (!zoneIdSet.has(zoneTimer.zoneId)) {
            // zoneTimer.availableOrgs.map((org: any) => {
            //   if (org.orgName === zoneTimer.orgName) {
            //     console.log('@@@zoneTimer.testLocation', zoneTimer.orgName)
            //     org.isSelected = true
            //   }
            // })
            zoneTimer.children = [{
              id: uuidv4(),
              location: zoneTimer.orgName,
              testLocation: zoneTimer.testLocation,
              orgId: zoneTimer.orgId,
              vGroupId: zoneTimer.vGroupId,
              zoneId: zoneTimer.zoneId,
              startTime: zoneTimer.start,
              timerInterval: zoneTimer.interval,
              // availableOrgs: zoneTimer.availableOrgs,
              timerRule
            }];
            zoneIdSet.add(zoneTimer.zoneId);
            tableData.value.push(zoneTimer);
          } else {
            const timer = tableData.value.find(item => item.id === zoneTimer.zoneId);
            // timer.availableOrgs.map((org: any) => {
            //   if (org.orgName === zoneTimer.orgName) {
            //     console.log('@@@zoneTimer.testLocation', zoneTimer.orgName)
            //     org.isSelected = true
            //   }
            // })
            timer.children.push({
              id: uuidv4(),
              location: zoneTimer.orgName,
              testLocation: zoneTimer.testLocation,
              orgId: zoneTimer.orgId,
              vGroupId: zoneTimer.vGroupId,
              zoneId: zoneTimer.zoneId,
              startTime: zoneTimer.start,
              timerInterval: zoneTimer.interval,
              // availableOrgs: timer.availableOrgs,
              timerRule
            });
          }
        } else {
          zoneIdSet.add(zoneTimer.zoneId);
          tableData.value.push(zoneTimer);
        }
      });
      console.log('@@@@tableData.value', tableData.value);
      stashedTableData = deepClone(tableData.value);
    };
    const computedTableData = computed(() => tableData.value.filter(data => !filterTimer.value || data?.zoneName.toLowerCase().includes(filterTimer.value.toLowerCase())));
    const currZone = ref();
    const showAddTimerDialog = data => {
      currZone.value = data;
      addTimerDialogVisible.value = true;
    };
    const addTimer = ([start, interval, org]) => {
      for (const zoneTimer of tableData.value) {
        if (zoneTimer.zoneId === currZone.value.zoneId) {
          if (zoneTimer?.children) {
            zoneTimer?.children.push({
              id: uuidv4(),
              location: org.orgName,
              testLocation: 'GLOBAL_AGENT',
              orgId: org.orgId,
              vGroupId: org.vGroupId,
              zoneId: zoneTimer.zoneId,
              startTime: start,
              timerInterval: interval,
              timerRule: []
            });
          } else {
            zoneTimer.children = [{
              id: uuidv4(),
              location: org.orgName,
              testLocation: 'GLOBAL_AGENT',
              orgId: org.orgId,
              vGroupId: org.vGroupId,
              zoneId: zoneTimer.zoneId,
              startTime: start,
              timerInterval: interval,
              timerRule: []
            }];
          }
        }
      }
    };
    const currLocationId = ref(0);
    const showDeleteTimerDialog = data => {
      currLocationId.value = data.id;
      deleteTimerDialogVisible.value = true;
    };
    const deleteTimer = () => {
      for (const zoneTimer of tableData.value) {
        if (zoneTimer?.children) {
          zoneTimer.children = zoneTimer.children.filter(timer => currLocationId.value !== timer.id);
        }
      }
    };
    const zoneTestLocation = ref();
    const showSelectTimerRuleDialog = data => {
      zoneTestLocation.value = data;
      selectTimerRuleDialogVisible.value = true;
    };
    let stashedTableData = [];
    const resetTimer = () => {
      tableData.value = deepClone(stashedTableData);
    };
    let originalTableData = [];
    const submitSetting = async () => {
      const timerSettingList = [];
      for (const zone of tableData.value) {
        if (zone?.children) {
          for (const item of zone.children) {
            timerSettingList.push({
              branchId: zone.branchId,
              interval: item.timerInterval.toString(),
              orgId: item.orgId,
              orgName: item.location,
              start: item.startTime,
              testLocation: item.testLocation,
              vGroupId: item.vGroupId,
              zoneId: item.zoneId,
              zoneName: zone.zoneName
            });
          }
        }
      }
      const stashedTimerSettingList = [];
      for (const zone of stashedTableData) {
        if (zone?.children) {
          for (const item of zone.children) {
            stashedTimerSettingList.push({
              branchId: zone.branchId,
              interval: item.timerInterval.toString(),
              orgId: item.orgId,
              orgName: item.location,
              start: item.startTime,
              testLocation: item.testLocation,
              vGroupId: item.vGroupId,
              zoneId: item.zoneId,
              zoneName: zone.zoneName
            });
          }
        }
      }
      const timerSettingMap = {};
      stashedTimerSettingList.map(item => {
        const key = `${item.zoneId}_${item.vGroupId}`;
        const timerSettingMapItem = originalTableData.find(timer => key === `${timer.zoneId}_${timer.vGroupId}`);
        timerSettingMap[key] = timerSettingMapItem;
      });
      // console.log('@@@timerSettingList', timerSettingList)
      // return
      const config = {
        url: `/monitor/cluster/timer-setting/${clusterId.value}`,
        method: 'post',
        headers: {
          userName: userCEC.value
        },
        data: {
          timerSettingList,
          timerSettingMap
        }
      };
      await mctRequest.request(config);
      ElMessage({
        type: 'success',
        message: 'Successfully updated'
      });
      setTimerDialogVisible.value = false;
    };
    watch(() => refreshSetTimer.value, () => {
      getTimerList();
    });
    watch(() => setTimerDialogVisible.value, () => {
      // console.log('setTimerDialogVisible.value', setTimerDialogVisible.value)
      if (setTimerDialogVisible.value) {
        getTimerList();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(setTimerDialogVisible),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(setTimerDialogVisible) ? setTimerDialogVisible.value = $event : null),
        "show-close": false,
        width: "70%"
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(DialogHeader, {
          onClose: close,
          "header-name": "Set Timer",
          "guide-link": "aaa"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          class: "w-50 m-2 filter-table",
          placeholder: "Filter the table",
          modelValue: filterTimer.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filterTimer.value = $event),
          "prefix-icon": _unref(Search)
        }, null, 8, ["modelValue", "prefix-icon"])]), _createVNode(_component_el_table, {
          data: computedTableData.value,
          style: {
            "width": "100%",
            "margin-bottom": "20px"
          },
          "row-key": "id",
          border: "",
          "default-expand-all": "",
          class: "set-timer-table",
          "row-class-name": tableRowClassName
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "zoneName",
            label: "Zone Name",
            width: "200"
          }), _createVNode(_component_el_table_column, {
            prop: "location",
            label: "Location"
          }, {
            default: _withCtx(scope => [scope.row.location ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(HomeFilled))]),
              _: 1
            }), _createElementVNode("span", _hoisted_4, _toDisplayString(scope.row.location), 1)])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "startTime",
            label: "Start Time"
          }, {
            default: _withCtx(scope => [scope.row?.timerRule ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: scope.row.startTime,
              "onUpdate:modelValue": $event => scope.row.startTime = $event,
              disabled: !!scope.row?.timerRule?.length
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(60).keys()], min => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: min,
                  label: min + ' min',
                  value: min
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "timerInterval",
            label: "Interval"
          }, {
            default: _withCtx(scope => [scope.row.timerInterval >= 0 ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: scope.row.timerInterval,
              "onUpdate:modelValue": $event => scope.row.timerInterval = $event,
              disabled: !!scope.row?.timerRule?.length,
              placeholder: "select interval"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "every 1 min",
                value: 1
              }), _createVNode(_component_el_option, {
                label: "every 2 min",
                value: 2
              }), _createVNode(_component_el_option, {
                label: "every 3 min",
                value: 3
              }), _createVNode(_component_el_option, {
                label: "every 4 min",
                value: 4
              }), _createVNode(_component_el_option, {
                label: "every 5 min",
                value: 5
              }), _createVNode(_component_el_option, {
                label: "every 6 min",
                value: 6
              }), _createVNode(_component_el_option, {
                label: "every 10 min",
                value: 10
              }), _createVNode(_component_el_option, {
                label: "every 12 min",
                value: 12
              }), _createVNode(_component_el_option, {
                label: "every 15 min",
                value: 15
              }), _createVNode(_component_el_option, {
                label: "every 20 min",
                value: 20
              }), _createVNode(_component_el_option, {
                label: "every 30 min",
                value: 30
              }), _createVNode(_component_el_option, {
                label: "every 60 min",
                value: 60
              })]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "ruleName",
            label: "Timer Rule"
          }, {
            default: _withCtx(scope => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.timerRule, (rule, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "rule-label"
              }, _toDisplayString(rule.ruleName), 1);
            }), 128))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "action",
            label: "Action"
          }, {
            default: _withCtx(scope => [!scope.row?.timerRule ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              class: "box-item",
              effect: "light",
              content: "Add Timer",
              placement: "top"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                icon: _unref(Plus),
                type: "primary",
                size: "small",
                circle: "",
                onClick: $event => showAddTimerDialog(scope.row)
              }, null, 8, ["icon", "onClick"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), scope.row?.timerRule ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 1,
              class: "box-item",
              effect: "light",
              content: "Delete Timer",
              placement: "top"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                icon: _unref(Close),
                type: "danger",
                size: "small",
                circle: "",
                onClick: $event => showDeleteTimerDialog(scope.row)
              }, null, 8, ["icon", "onClick"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), scope.row?.timerRule ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 2,
              class: "box-item",
              effect: "light",
              content: "Select Timer Rule",
              placement: "top"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                icon: _unref(User),
                type: "warning",
                size: "small",
                circle: "",
                onClick: $event => showSelectTimerRuleDialog(scope.row)
              }, null, 8, ["icon", "onClick"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[1] || (_cache[1] = $event => setTimerDialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode(" Cancel ")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: resetTimer,
          plain: ""
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("Reset")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitSetting
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("Submit")])),
          _: 1
        })]), _createVNode(_component_el_dialog, {
          modelValue: _unref(addTimerDialogVisible),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(addTimerDialogVisible) ? addTimerDialogVisible.value = $event : null),
          "show-close": false,
          width: "50%"
        }, {
          header: _withCtx(({
            close
          }) => [_createVNode(DialogHeader, {
            onClose: close,
            "header-name": "Add Timer",
            "guide-link": "aaa"
          }, null, 8, ["onClose"])]),
          default: _withCtx(() => [_unref(addTimerDialogVisible) ? (_openBlock(), _createBlock(AddTimer, {
            key: 0,
            "zone-info": currZone.value,
            onAddTimer: addTimer
          }, null, 8, ["zone-info"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: _unref(deleteTimerDialogVisible),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(deleteTimerDialogVisible) ? deleteTimerDialogVisible.value = $event : null),
          "show-close": false,
          width: "30%"
        }, {
          header: _withCtx(({
            close
          }) => [_createVNode(DialogHeader, {
            onClose: close,
            "header-name": "Delete Timer",
            "guide-link": "aaa"
          }, null, 8, ["onClose"])]),
          default: _withCtx(() => [_createVNode(DeleteTimer, {
            onDeleteTimer: deleteTimer
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: _unref(selectTimerRuleDialogVisible),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(selectTimerRuleDialogVisible) ? selectTimerRuleDialogVisible.value = $event : null),
          "show-close": false,
          width: "50%"
        }, {
          header: _withCtx(({
            close
          }) => [_createVNode(DialogHeader, {
            onClose: close,
            "header-name": "Select Timer Rule",
            "guide-link": "aaa"
          }, null, 8, ["onClose"])]),
          default: _withCtx(() => [_unref(selectTimerRuleDialogVisible) ? (_openBlock(), _createBlock(SelectTimerRule, {
            key: 0,
            "zone-test-location": zoneTestLocation.value
          }, null, 8, ["zone-test-location"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: _unref(timerRuleDialogVisible),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(timerRuleDialogVisible) ? timerRuleDialogVisible.value = $event : null),
          "show-close": false,
          width: "60%"
        }, {
          header: _withCtx(({
            close
          }) => [_createVNode(DialogHeader, {
            onClose: close,
            "header-name": "Timer Rule",
            "guide-link": "aaa"
          }, null, 8, ["onClose"])]),
          default: _withCtx(() => [_createVNode(TimerRule)]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: _unref(deleteTimerRoleDialogVisible),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(deleteTimerRoleDialogVisible) ? deleteTimerRoleDialogVisible.value = $event : null),
          "show-close": false,
          width: "30%"
        }, {
          header: _withCtx(({
            close
          }) => [_createVNode(DialogHeader, {
            onClose: close,
            "header-name": "Delete Timer Rule",
            "guide-link": "aaa"
          }, null, 8, ["onClose"])]),
          default: _withCtx(() => [_createVNode(DeleteTimerRule)]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});